import {
  defaultBase,
  defaultSettings,
} from '@components/Widgets/_contentItems/_baseTemplate'
import { countdownType } from './_meta'

export const defaultStyling = {
  fontFamily: 'Roboto',
  fontSize: '22px',
  fontWeight: 'normal',
  color: 'rgb(24, 23, 26)',
  textAlign: 'center',
  borderRadius: '0px',
  borderWidth: '2px',
  borderColor: '#000000',
}

export default {
  id: '02534345',
  type: 'countdown',
  category: 'other',
  ...defaultBase,
  content: {
    text: '',
  },
  settings: {
    ...defaultSettings,
    timerType: countdownType.FIXED_EXPIRATION, // or 'INDIVIDUAL_COUNTDOWN'
    fixedExpiration: '2025-12-31T23:59:59Z',
    individualDuration: 3600, // total duration in seconds (e.g., 1 hour)
    timezone: 'UTC',
  },
  styling: { ...defaultStyling },
}
